import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import './global.css';
import { installNumberInputWheelGuard } from './utils/disableNumberInputWheel';
import { registerServiceWorker } from './pwa/registerServiceWorker';
import App from './App';

installNumberInputWheelGuard();
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
